/* eslint-disable */
// AUTO-GENERATED by scripts/generate-custom-icon-manifest.js — do not edit.
// Source folder: public/icons/*.png

export const customIconFileNames = [
  "airplane.png",
  "airport.png",
  "antenna.png",
  "aquarium.png",
  "assembly-point.png",
  "atm-card.png",
  "bakery.png",
  "band-aid.png",
  "bank.png",
  "bar.png",
  "beach.png",
  "bed.png",
  "bicycle.png",
  "bike.png",
  "binoculars.png",
  "boxes.png",
  "briefcase.png",
  "bus-stop (1).png",
  "bus-stop (2).png",
  "bus-stop.png",
  "cafe.png",
  "camera.png",
  "car.png",
  "carts.png",
  "charging-station.png",
  "church.png",
  "crowd.png",
  "cyclocross.png",
  "delivery.png",
  "dentist.png",
  "drinking-water.png",
  "education.png",
  "employee.png",
  "enterprise.png",
  "factory (1).png",
  "factory.png",
  "fast-shipping.png",
  "ferry.png",
  "fire-hydrant.png",
  "first-aid-kit.png",
  "flags.png",
  "forklift.png",
  "garden.png",
  "gas-pump.png",
  "healthy.png",
  "heart.png",
  "historic.png",
  "home.png",
  "hospital.png",
  "hotel.png",
  "info-center.png",
  "lake.png",
  "landscape.png",
  "library.png",
  "location-pin.png",
  "location.png",
  "market.png",
  "medical-team.png",
  "metro.png",
  "milestone.png",
  "monument.png",
  "mountain.png",
  "museum.png",
  "music.png",
  "navigator.png",
  "no-parking.png",
  "park (1).png",
  "park.png",
  "parking-barrier.png",
  "parking-sign.png",
  "parking-ticket.png",
  "path.png",
  "person.png",
  "pharmacy.png",
  "picnic-basket.png",
  "pin.png",
  "placeholder.png",
  "playground.png",
  "police.png",
  "public-toilet.png",
  "pushpin.png",
  "restaurant.png",
  "scooter.png",
  "shield.png",
  "shop-bag.png",
  "shopping.png",
  "shower.png",
  "sign (1).png",
  "sign.png",
  "stadium.png",
  "status-1.png",
  "status-2.png",
  "status-3.png",
  "status-4.png",
  "status-5.png",
  "status-bookmark.png",
  "status-check.png",
  "status-clock.png",
  "status-coin.png",
  "status-cross.png",
  "status-exclamation.png",
  "status-lock.png",
  "status-minus.png",
  "status-moon.png",
  "status-play.png",
  "status-plus.png",
  "status-question.png",
  "status-star.png",
  "status-sun.png",
  "status-thumbs-up.png",
  "supermarket.png",
  "taxi (1).png",
  "taxi-app.png",
  "taxi.png",
  "tent.png",
  "theater.png",
  "theme-park.png",
  "ticket (1).png",
  "ticket.png",
  "toilets.png",
  "tow.png",
  "train-station.png",
  "train.png",
  "tree.png",
  "truck.png",
  "vacations.png",
  "viewpoint.png",
  "walk.png",
  "warehouse (1).png",
  "warehouse.png",
  "warning-sign.png",
  "wheelchair.png",
  "wifi-signal (1).png",
  "wifi-signal.png",
  "workers.png",
  "wrench.png",
  "zoo.png"
];
